export const canMobilePunch = (user) =>
  user?.is_allow_mobilepunch === 1 || user?.is_allow_mobilepunch === "1";

export const MOBILE_PUNCH_DENIED_MESSAGE = "Mobile punching is not enabled for your account.";
